export default "__VITE_ASSET__DwIPT$M7__"